module.exports = __webpack_public_path__ + "static/media/1200px-React-icon.svg.580ffd26.png";